export default __webpack_public_path__ + "static/media/how-much-js.83f4a96e.png";